import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA} from "@angular/material/dialog";
import { SnackBarService } from '../../service/snack.bar.service';
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { GraphQLError } from "graphql";
import { MatCheckboxChange } from "@angular/material/checkbox";
import { AddSalesGalleryCloseDateGQL,ViewCloseDateByIdGQL,EditSalesGalleryCloseDateGQL} from "../../../../generated/graphql";
import * as moment from "moment";

export enum FormRequestType {
  EDIT = "edit",
  ADD = "create"
}

export interface DialogData {
  type: string;
}

@Component({
  selector: 'add-close-date-dialog',
  templateUrl: 'add-close-date-dialog.html',
  styleUrls: []
})


export class AddCloseDateDialog{
  result: DialogData = {
    type: "",
  };
  formGrp: FormGroup;
  projectId: string;
  appointmentScheduleId : string; 
  startTimefromProjectLvl : string ; 
  endTimefromProjectLvl : string ; 
  initialTime : any ;
  formTypeRequest = FormRequestType;
  formType: string;
  closeId : string ;
  title : string; 
  minDate: Date = new Date();

  constructor(
    public dialogRef: MatDialogRef<AddCloseDateDialog>,
    private snackBarService: SnackBarService,
    @Inject(MAT_DIALOG_DATA) private data: DialogData,
    private snackBarSvc: SnackBarService,
    private addSalesGalleryCloseDateGQL : AddSalesGalleryCloseDateGQL,
    private viewCloseDateByIdGQL : ViewCloseDateByIdGQL,
    private editSalesGalleryCloseDateGQL: EditSalesGalleryCloseDateGQL

  ) {
    this.formType = data.type
    this.initFormControl();
    this.patchData(data);

  }
  private initFormControl() {
    this.formGrp = new FormGroup(
      {
      startDate: new FormControl(""),
      endDate: new FormControl(""),
      startTime: new FormControl(""),
      endTime: new FormControl("")
      }
    );
  }

  onSubmit(){
    if(this.formGrp.controls.startDate.value > this.formGrp.controls.endDate.value){
      this.snackBarService.show(
        "Please Select Valid Dates and Time "
      );
    }
    else if (this.formGrp.valid){
      if (this.data.type == this.formTypeRequest.ADD){
        this.addSalesGalleryCloseDateGQL
        .mutate({
          input :{
            appointmentScheduleId : this.appointmentScheduleId,
            projectId : this.projectId,
            startDate : this.formGrp.controls.startDate.value,
            endDate : this.formGrp.controls.endDate.value,
            startTime : this.formGrp.controls.startTime.value,
            endTime : this.formGrp.controls.endTime.value
          }
        })
        .subscribe(result => {
          if (result.data.addSalesGalleryCloseDate) {
            this.snackBarService.show("Add successfully");
            this.dialogRef.close(result);
          }
        }, (err: GraphQLError) => {
          this.snackBarService.showMutationError(err);
        });
      }
      else if (this.data.type == this.formTypeRequest.EDIT){
        this.editSalesGalleryCloseDateGQL
        .mutate({
          input :{
            id: this.closeId,
            appointmentScheduleId : this.appointmentScheduleId,
            projectId : this.projectId,
            startDate : this.formGrp.controls.startDate.value,
            endDate : this.formGrp.controls.endDate.value,
            startTime : this.formGrp.controls.startTime.value,
            endTime : this.formGrp.controls.endTime.value
          }
        })
        .subscribe(result => {
          if (result.data.editSalesGalleryCloseDate) {
            this.snackBarService.show("Edit successfully");
            this.dialogRef.close(result);
            this.patchData(this.data);
          }
        }, (err: GraphQLError) => {
          this.snackBarService.showMutationError(err);
        });
      }
    }
    else {
      this.snackBarService.show(
        "Please complete or correct the required field(s)."
      ); 
    }
  }

  patchData(data) {
    if (data.type == this.formTypeRequest.ADD){
      this.title = "Add"
      this.projectId = data.projectId;
      this.appointmentScheduleId = data.id;
      this.startTimefromProjectLvl = data.startTime;
      this.endTimefromProjectLvl = data.endTime;
      this.initialTime = [this.startTimefromProjectLvl, this.endTimefromProjectLvl]
    }
    else if (data.type == this.formTypeRequest.EDIT){
      this.title = "Edit"
      this.viewCloseDateByIdGQL.fetch({
        id: data.closeId
      }).subscribe(
        (result)  =>{
          if (result?.errors) return this.snackBarService.showQueryError(result.errors);

          let blockDateById = result.data.viewCloseDateById;
          this.formGrp.controls.startDate.setValue(
            blockDateById.startDate
          )
          this.formGrp.controls.endDate.setValue(
            blockDateById.endDate
          )
          this.formGrp.controls.startTime.setValue(
            blockDateById.startTime
          )
          this.formGrp.controls.endTime.setValue(
            blockDateById.endTime
          )
          this.closeId = blockDateById.id
          this.appointmentScheduleId= blockDateById.appointmentSchedulingId
          this.projectId = blockDateById.projectId
          this.startTimefromProjectLvl = data.startTime;
          this.endTimefromProjectLvl = data.endTime;
          this.initialTime = [this.startTimefromProjectLvl, this.endTimefromProjectLvl]
        }
      )
    }
  }

  isCheck(e:MatCheckboxChange , data) {
    if (e.checked){
      this.formGrp.controls.startTime.setValue(data[0]);
      this.formGrp.controls.endTime.setValue(data[1]);      
    }else {
      this.formGrp.controls.startTime.setValue('--: --');
      this.formGrp.controls.endTime.setValue('--: --');    
    }
 }

}


